<template>
    <div class="col-sm-12 col-xl-4 text-start">
                <div class="card">
                  <div class="card-header pb-0">
                    <h3>Bold (700)</h3>
                  </div>
                  <div class="card-body typography">
                    <h1 class="f-w-700">Heading 1</h1>
                    <h2 class="f-w-700">Heading 2</h2>
                    <h3 class="f-w-700">Heading 3</h3>
                    <h4 class="f-w-700">Heading 4</h4>
                    <h5 class="f-w-700">Heading 5</h5>
                    <h6 class="f-w-700">Heading 6</h6>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xl-4 text-start">
                <div class="card">
                  <div class="card-header pb-0">
                    <h3>Extra Bold (900)</h3>
                  </div>
                  <div class="card-body typography">
                    <h1 class="f-w-900">Heading 1</h1>
                    <h2 class="f-w-900">Heading 2</h2>
                    <h3 class="f-w-900">Heading 3</h3>
                    <h4 class="f-w-900">Heading 4</h4>
                    <h5 class="f-w-900">Heading 5</h5>
                    <h6 class="f-w-900">Heading 6</h6>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 text-start">
                <div class="card">
                  <div class="card-header pb-0">
                    <h3>Headings</h3><span>Use the included utility classes to recreate the small secondary heading text.  </span>
                  </div>
                  <div class="card-body typography">
                    <h3>Fancy display heading<small class="text-muted">With faded secondary text</small></h3>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 text-start">
                <div class="card">
                  <div class="card-header pb-0">
                    <h3>Display headings</h3><span>Traditional heading elements are designed to work best in the meat of your page content. When you need a heading to stand out, consider using a <strong>display heading</strong>—a larger, slightly more opinionated heading style.</span>
                  </div>
                  <div class="card-body typography">
                    <h1 class="display-1">Display 1</h1>
                    <h1 class="display-2">Display 2</h1>
                    <h1 class="display-3">Display 3</h1>
                    <h1 class="display-4">Display 4</h1>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 text-start">
                <div class="card">
                  <div class="card-header pb-0">
                    <h3>Lead</h3><span>Make a paragraph stand out by adding <code>.lead</code>.</span>
                  </div>
                  <div class="card-body">
                    <p class="lead">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-xl-6 text-start">
                <div class="card">
                  <div class="card-header pb-0">
                    <h3>Inline text elements</h3><span>Styling for common inline HTML5 elements.</span>
                  </div>
                  <div class="card-body">
                    <p>You can use the mark tag to 
                      <mark>highlight</mark> text.
                    </p>
                    <p>
                      <del>This line of text is meant to be treated as deleted text.</del>
                    </p>
                    <p>
                      <s>This line of text is meant to be treated as no longer accurate.</s>
                    </p>
                    <p><ins>This line of text is meant to be treated as an addition to the document.</ins></p>
                    <p>
                      <u>This line of text will render as underlined</u>
                    </p>
                    <p><small>This line of text is meant to be treated as fine print.</small></p>
                    <p><strong>This line rendered as bold text.</strong></p>
                    <p><em>This line rendered as italicized text.</em></p>
                  </div>
                </div>
              </div>
</template>